import { 
  // createSlice,
  configureStore
} from '@reduxjs/toolkit'

import stationsReducer from './stationsSlice'
import noticesReducer from './noticesSlice'
import userReducer from './userSlice'

// const uiSlice = createSlice({
//   name: 'ui',
//   initialState: {
//     currentPage: 'home'
//   },
//   reducers: {
//     pageChanged: (state, action) => {
//       state.currentPage = action.payload
//     },
//   }
// })

// export const { pageChanged } = uiSlice.actions

export const store = configureStore({
  reducer: {
    stations: stationsReducer,
    notices: noticesReducer,
    user: userReducer,
  }
})

